/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TermsOfBusiness from "./TermsOfBusiness";
import ActionBar from "../shared/general/ActionBar";
import Subscriptions from "./Subscriptions";
import ErrorBoundary from "../shared/error/ErrorBoundary";

export const SubscriptionPlans = ({ termsModalActive }) => (
  <Fragment>
    <ErrorBoundary>
      {termsModalActive && <TermsOfBusiness />}
      <ActionBar title="membership plans" mobileTitle="membership plans" />
      <Subscriptions />
    </ErrorBoundary>
  </Fragment>
);

SubscriptionPlans.propTypes = {
  termsModalActive: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  termsModalActive: state.subscriptionPlans.termsModalActive,
});

export default connect(mapStateToProps)(SubscriptionPlans);
